import { useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { fmtDateTime } from "@/lib/checkins";
import { errMsg } from "./ResolveDialog";

const HOLD = { safety: "safety response", red_domain: "red domain", incomplete: "not enough information",
  contact_requested: "contact requested", review_mode: "review-before-release mode" };

// Release / withhold the client summary (hybrid & review modes hold flagged results).
export function FeedbackControls({ sub, readOnly, onChanged }) {
  const fb = sub.feedback;
  const [msg, setMsg] = useState("");
  const [busy, setBusy] = useState(false);
  async function call(path, body) {
    setBusy(true);
    try {
      await api.post(`/checkin-feedback/${sub.id}/${path}`, body);
      toast.success(path === "release" ? "Summary released — client emailed a secure link" : "Summary withheld");
      onChanged();
    } catch (e) {
      toast.error("Failed", { description: errMsg(e) });
    } finally {
      setBusy(false);
    }
  }
  const held = ["held", "pending", "withheld"].includes(fb.release_status);
  return (
    <div className="rounded-lg border border-zinc-200 bg-zinc-50 p-3 text-sm" data-testid="checkin-feedback-controls">
      <div className="flex flex-wrap items-center gap-2">
        <span className="font-semibold text-zinc-900">Client summary:</span>
        <span data-testid="checkin-feedback-status" className={fb.release_status === "released" ? "text-emerald-800 font-semibold" : "text-amber-800 font-semibold"}>
          {fb.release_status === "released" ? `Released ${fmtDateTime(fb.released_at)}` : fb.release_status === "withheld" ? "Withheld" : "Held for review"}
        </span>
        {fb.hold_reasons?.length > 0 && <span className="text-xs text-zinc-600">({fb.hold_reasons.map((h) => HOLD[h] || h).join(", ")})</span>}
        {fb.rating && <span className="text-xs text-zinc-600">· client rated: {fb.rating === "useful" ? "useful" : "not useful"}</span>}
      </div>
      {fb.practitioner_message && <p className="mt-1 text-xs text-zinc-700">Message to client: {fb.practitioner_message}</p>}
      {!readOnly && held && (
        <div className="mt-2 space-y-2">
          <Textarea rows={2} placeholder="Optional message shown on the client's summary" value={msg} onChange={(e) => setMsg(e.target.value)} data-testid="checkin-release-message" />
          <div className="flex gap-2">
            <Button size="sm" disabled={busy} onClick={() => call("release", { message: msg || null })} data-testid="checkin-release-btn">Release summary</Button>
            {fb.release_status !== "withheld" && (
              <Button size="sm" variant="outline" disabled={busy} data-testid="checkin-withhold-btn"
                onClick={() => { const r = window.prompt("Reason for withholding the automated summary?"); if (r && r.trim().length >= 3) call("withhold", { reason: r.trim() }); }}>
                Withhold
              </Button>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
